import { usePrevious } from '@client/hooks/use-utils.hooks';
import { tryCatch } from '@shared/helpers/utils.helpers';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';

type Toggle = (next: boolean) => void;

/** not sure about how safe this is.. keeping it in here for now */
const useDefer = () => {
  const timeoutRef = useRef<number>(undefined);

  useEffect(() => () => clearTimeout(timeoutRef.current), []);

  return useCallback((callback: () => void) => {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = window.setTimeout(callback, 0);
  }, []);
};

export const useOptimisticBoolean = (
  value: boolean,
  onChange: (newValue: boolean) => void,
): [currentValue: boolean, toggle: Toggle] => {
  const defer = useDefer();

  const [internalValue, setInternalValue] = useState(value);
  if (usePrevious(value, { setInitial: true }) !== value)
    setInternalValue(value);

  const toggle = useCallback(
    (newValue: boolean) => {
      setInternalValue(newValue);
      defer(() => {
        const { ok } = tryCatch(() => onChange(newValue));
        if (!ok) setInternalValue(value);
      });
    },
    [defer, value, onChange],
  );

  return useMemo(() => [internalValue, toggle], [internalValue, toggle]);
};
